import React, { Component } from 'react';
import { browserHistory } from 'react-router'

class Logo extends Component {

  onClick(e) {
    e.preventDefault()
    browserHistory.push('/')
  }

  render() {
    return (
      <a className="logo btn btn--red" onClick={this.onClick.bind(this)} >waat<span className="ext">.tv</span></a>
    )
  }
}

export default Logo



/** WEBPACK FOOTER **
 ** ./src/scripts/components/Logo.js
 **/